import { paginationOptions, navigationOptions } from "Config/slider/default"
import { productsSliderOptions, productSectionSliderOptions } from "Config/slider/product"
import { indexBannerSliderOptions } from "Config/slider/index-banner"
import { smallProductsSliderOptions } from "Config/slider/small-product"

import { rSwiperVisibleItems } from 'Functions/swiper-visible-items'
import { rSwiperCssNavFix } from 'Functions/swiper-css-nav-fix'
import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper';
import { catalogSectionSliderOptions } from "Config/slider/catalog";


export const sliderOptions = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        roundLengths: true,
        modules: [Pagination, Navigation, EffectFade, Autoplay, rSwiperVisibleItems, rSwiperCssNavFix]
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-products')) {
        const maxVisibleItems = instance.hasAttribute('r-max-visible-items') ? instance.getAttribute('r-max-visible-items') : 10
        options = {...options, ...productsSliderOptions(instance, options, maxVisibleItems)}
    }

    if (instance.hasAttribute('r-slider-products-section')) {
        const maxVisibleItems = instance.hasAttribute('r-max-visible-items') ? instance.getAttribute('r-max-visible-items') : 10
        options = {...options, ...productSectionSliderOptions(instance, options, maxVisibleItems)}
    }

    if (instance.hasAttribute('r-slider-catalogs-section')) {
        const maxVisibleItems = instance.hasAttribute('r-max-visible-items') ? instance.getAttribute('r-max-visible-items') : 10
        options = {...options, ...catalogSectionSliderOptions(instance, options, maxVisibleItems)}
    }

    if (instance.hasAttribute('r-slider-products-small')) {
        const maxVisibleItems = instance.hasAttribute('r-max-visible-items') ? instance.getAttribute('r-max-visible-items') : 10
        options = {...options, ...smallProductsSliderOptions(instance, options, maxVisibleItems)}
    }

    if (instance.hasAttribute('r-slider-index-banner')) {
        options = {...options, ...indexBannerSliderOptions(instance, options, instance.labels)}
    }

    return {...options, ...instance.customOptions}
}